export const PresenceEvents = {
  GAME_ENGINE_UPDATE: 'ges:update',
  MATCH_START: 'ges:match:start',
  MATCH_END: 'ges:match:end',
  MATCH_UPDATE: 'ges:match:update',
  MATCH_CREATED: 'ges:match:created',
  MATCH_DESTROYED: 'ges:match:destroyed',
  LOBBY_UPDATE: 'ges:lobby:update',
  LOBBY_CREATED: 'ges:lobby:created',
  MATCH_MADE: 'ges:match:made'
};

/**
 * GES tag indicating the client should use its local engine (SP fallback from MP).
 */
export const GES_TAG_CLIENT_ENGINE = 'client';

export const LobbyBrowserEvents = {
  ONLINE_STATUS: 'client:browser:online:status',
  LOBBY_STATUS: 'client:browser:lobby:status',
  SERVER_STATUS: 'client:browser:server:status',
  LOBBY_CREATED: 'server:browser:lobby:created',
  LOBBY_DESTROYED: 'server:browser:lobby:destroyed',
  LOBBY_UPDATED: 'server:browser:lobby:updated'
};

export const LobbyEvents = {
  JOIN: 'client:room:join',
  LEAVE: 'client:room:leave',
  CREATE: 'client:room:create',
  DESTROY: 'client:room:destroy',
  UPDATE: 'client:room:update',
  KICK: 'client:room:kick',
  READY: 'client:room:ready',
  MESSAGE: 'client:room:message',
  CURRENT_LOBBY: 'server:room:current',
  NO_LOBBIES_FOUND_ERR: 'client:room:no-lobbies-found',
  ON_KICK: 'server:room:kicked',
  ON_JOIN: 'server:room:joined',
  ON_LEAVE: 'server:room:left',
  ON_CREATE: 'server:room:created',
  ON_DESTROY: 'server:room:destroyed',
  ON_UPDATE: 'server:room:updated',
  ON_READY: 'server:room:ready'
};

export const GeneralSocketEvents = {
  CONNECTION: 'connection',
  DISCONNECT: 'disconnect',
  ERROR: 'error',
  RECONNECT: 'reconnect',
  SERVER_ERROR: 'server:error',
  SYSTEM_ERROR: 'system:error'
};

export const LobbyChannels = {
  NOVA_ALL: 'nova-all',
  LOBBY_BROWSER: 'lobby-browser',
  LOBBY: (lobbyId: string) => 'lobby:' + lobbyId
};
